export default __webpack_public_path__ + "static/media/hulu-screenshot.4b1e9ae5.png";